<template>
  <div class="contents contents--full">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>{{ orgName }}의 내부통제체계 진단 결과</h3>
        <!-- <select v-model="selectedYear" class="year-dropdown">
          <option v-for="year in availableYears" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <button @click="yearLoadData" class="excel-download-btn">조회</button>
        <button @click="downloadExcel" class="excel-download-btn">엑셀 다운로드</button> -->
        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>{{ orgName }}의 내부통제체계 진단 결과</span>
        </div>
      </div>
      <br />

     <div class="excel-actions">
      <div class="excel-download-container">
        <button @click="downloadExcel" class="excel-download-btn">총괄표 다운로드</button>
      </div>
      <div class="excel-download-container">
        <button @click="downloadExcelAll" class="excel-download-btn">통합 점수표 엑셀 다운로드</button>
      </div>
      <div class="excel-download-container">
        <button @click="downloadExcel_2" class="excel-download-btn">통제활동 내역 다운로드</button>
      </div>
    </div>
      <!-- 통계 테이블 -->
      <div class="stats-table-container">
        <table ref="statsTableRef" class="stats-table">

          <thead>
            <tr>
              <th>(Level 1)         <br /> Component</th> <!-- 도메인 -->
              <th>(Level 2)         <br />Tactical Organizational Objectives</th> <!-- 프린서펄 -->
              <th>(Level 3) Internal Control Objective</th> <!-- 스탠다드 -->
              <th>(Level 4) Control Activity</th>
              <th>actual point</th>
              <th>Control weight</th>
              <th>weighted point</th>
              <th>Control Objective Rating</th> 
              <th>Control Objective Weight</th> 
              <th>weighted point</th> 
              <th>Total weight</th> 
              <th>Total weighted point</th> 
              <th>Tactical Organizational Objectives(100)</th> 
              <th>Tactical Organizational Objectives(IMS)</th> 
              <th>Component</th> 
              <th>Total</th> 
            </tr>
          </thead>
          <tbody>
            <template v-for="(domain, domainIndex) in transformedDomains" :key="domainIndex">
              <template v-for="(principle, principleIndex) in domain.principles" :key="principleIndex">
                <template v-for="(standard, standardIndex) in principle.standards" :key="standardIndex">
                  <template v-for="(evaluation, evalIndex) in standard.evaluations" :key="evalIndex">
                    <tr>
                      <!-- Domain -->
                      <td v-if="principleIndex === 0 && standardIndex === 0 && evalIndex === 0"
                          :rowspan="getDomainRowspan(domain)">
                          <span class="code-badge">{{ domain.domainCode }}.</span>
                          <span class="name" v-html="formatName(domain.domainName)"></span>
                      </td>
                      <!-- Principle -->
                      <td class="principle-cell" v-if="standardIndex === 0 && evalIndex === 0"
                          :rowspan="getPrincipleRowspan(principle)">
                        <span class="principle-code-badge">{{ principle.principleCode }}.</span>
                        <span class="principle-name" v-html="formatName(principle.principleName)"></span>
                      </td>
                      <!-- Standard -->
                      <td v-if="evalIndex === 0"
                          :rowspan="standard.evaluations.length">
                        <span class="code-badge">{{ standard.standardCode }}</span>
                                <br />
                        <span class="name" v-html="formatName(standard.standardName)"></span>
                      </td>
                      <!-- Evaluation -->
                      <td>
                        {{ evaluation.evaluationCode }}
                        <br />
                        {{ evaluation.evaluationName }}
                      </td>
                      <td class="avg-score" >{{ evaluation.evaluationScore }}</td>
                      <td>{{ evaluation.evaluationWeight }}</td>
                      <td class="avg-score">{{ evaluation.weightedPoint }}</td>
                      <!-- Standard 가중치 -->
                      <td v-if="evalIndex === 0" :rowspan="standard.evaluations.length">
                        {{ standard.controlObjectiveRating2d }}
                      </td>
                      <td v-if="evalIndex === 0" :rowspan="standard.evaluations.length" class="avg-score">
                         {{ standard.standardWeight }}
                      </td>
                      <td v-if="evalIndex === 0" :rowspan="standard.evaluations.length">
                         {{ standard.weightedControlObjective2d }}  <!-- controlObjectiveRating * standardWeight -->
                      </td>
                      <!-- Principle 가중치 -->
                      <td v-if="standardIndex === 0 && evalIndex === 0" :rowspan="getPrincipleRowspan(principle)" class="avg-score">
                        {{ principle.totalStandardWeight }}
                      </td>
                      <td v-if="standardIndex === 0 && evalIndex === 0" :rowspan="getPrincipleRowspan(principle)">
                        {{ principle.totalWeightedControlObjective }}
                      </td>
                      <td v-if="standardIndex === 0 && evalIndex === 0" :rowspan="getPrincipleRowspan(principle)" class="avg-score">
                        {{ principle.tacticalOrganizationalObjectives1002d }}
                      </td>
                       <td v-if="standardIndex === 0 && evalIndex === 0" :rowspan="getPrincipleRowspan(principle)">
                        {{ principle.tacticalObjectivePrinciple2d }}
                      </td>
                      <!-- Domain 가중치 -->
                      <td v-if="principleIndex === 0 && standardIndex === 0 && evalIndex === 0" :rowspan="getDomainRowspan(domain)" class="avg-score">
                       {{ domain.domainTacticalSum2d }}
                      </td>
                      <td v-if="domainIndex === 0 && principleIndex === 0 && standardIndex === 0 && evalIndex === 0"
                        :rowspan="overallRowspan">
                      {{ totalScoreVal }}
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </template>
          </tbody>
          
        </table>
      </div>
    </div>
  </div>

</template>


<script setup>
import { reactive, ref, computed, onMounted,onUnmounted  } from "vue";
import { useStore } from "vuex";
import { useRouter,useRoute } from 'vue-router'
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
const store = useStore();
const route = useRoute()

// 도메인 데이터 가져오기
const orgEvlList = computed(() => store.state.grid.evlOrgData2);// 평가데이터 가져오기기

const checkUserId = computed(() => store.state.temp.userInfo);

// 연도 콤보박스 선택된 값
const selectedYear = ref('2025');

// 연도 목록 (현재 연도부터 과거 5년까지)
const availableYears = ref(
  Array.from({ length: 2 }, (_, i) => new Date().getFullYear() - i)
);

// 전체 합계: API가 각 row에 같은 값을 주는 형태라면 첫 유효값만 집어오면 됩니다.
const totalScoreVal = computed(() => {
  for (const row of orgEvlList.value) {
    const v = Number(row.totalScore);
    if (Number.isFinite(v)) return Number(v.toFixed(1)); // 소수1자리 표준화
  }
  return null;
});

// 테이블 전체 rowspan(= 모든 evaluation row 수)
const overallRowspan = computed(() => {
  const tree = transformedDomains.value;
  let cnt = 0;
  for (const d of tree) {
    for (const p of d.principles) {
      for (const s of p.standards) {
        cnt += s.evaluations.length;
      }
    }
  }
  return cnt;
});

// 트리 데이터 생성
const transformedDomains = computed(() => transformToTreeStructure(orgEvlList.value));

// 트리 구조 변환 함수
const transformToTreeStructure = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    if (!groupedData[item.domainCode]) {
      groupedData[item.domainCode] = {
        domainCode: item.domainCode,
        domainName: item.domainName,
        domainTacticalSum2d : item.domainTacticalSum2d,
        principles: {},
      };
    }
    const domain = groupedData[item.domainCode];

    if (!domain.principles[item.principleCode]) {
      domain.principles[item.principleCode] = {
        principleCode: item.principleCode,
        principleName: item.principleName,
        totalStandardWeight : item.totalStandardWeight,
        totalWeightedControlObjective : item.totalWeightedControlObjective,
        tacticalOrganizationalObjectives1002d : item.tacticalOrganizationalObjectives1002d,
        tacticalObjectivePrinciple2d : item.tacticalObjectivePrinciple2d,

        standards: {},
      };
    }
    const principle = domain.principles[item.principleCode];

    if (!principle.standards[item.standardCode]) {
      principle.standards[item.standardCode] = {
        standardCode: item.standardCode,
        standardName: item.standardName,
        controlObjectiveRating2d : item.controlObjectiveRating2d,
        standardWeight : item.standardWeight,
        weightedControlObjective2d : item.weightedControlObjective2d,
        totalEvaluationWeight : item.totalEvaluationWeight,
        totalWeightedPoint : item.totalWeightedPoint,

        evaluations: [],
      };
    }
    const standard = principle.standards[item.standardCode];

    standard.evaluations.push({
      evaluationCode: item.evaluationCode,
      evaluationName: item.evaluationName,
      evaluationScore : item.evaluationScore,
      evaluationWeight : item.evaluationWeight,
      weightedPoint : item.weightedPoint,
      approach : item.approach,
      deployment : item.deployment,
      monitoringProcess : item.monitoringProcess,
      action : item.action,
      approachScore : item.approachScore,
      deploymentScore : item.deploymentScore,
      monitoringScore : item.monitoringScore,
      actionScore : item.actionScore,

      approachStr : item.approachStr,
      deploymentStr : item.deploymentStr,
      monitotingStr : item.monitotingStr,
      actionStr : item.actionStr,
      approachWeak : item.approachWeak,
      deploymentWeak : item.deploymentWeak,
      monitotingWeak : item.monitotingWeak,
      actionWeak : item.actionWeak
    });
  });

  return Object.values(groupedData).map((domain) => ({
    ...domain,
    principles: Object.values(domain.principles).map((principle) => ({
      ...principle,
      standards: Object.values(principle.standards),
    })),
  }));
};


// rowspan 계산
const getDomainRowspan = (domain) => {
  return domain.principles.reduce((total, principle) => {
    return total + principle.standards.reduce((count, standard) => count + standard.evaluations.length, 0);
  }, 0);
};
const getPrincipleRowspan = (principle) => {
  return principle.standards.reduce((count, standard) => count + standard.evaluations.length, 0);
};

// 텍스트에 <br> 삽입하는 함수
const formatName = (name) => {
  if (!name) return "";
  return name.replace(/\(/g, "<br>("); // '(' 이전에 <br> 추가
};

// 요약 그리드 점수별로 배경색 바꾸기
const getScoreClass = (score) => {
  if (!score || score === "평가중") return "score-pending";
  if (score >= 80) return "score-excellent";
  if (score >= 60) return "score-satisfactory";
  if (score >= 40) return "score-needs-improvement";
  if (score >= 20) return "score-weak";
  return "score-very-weak";
};

// 모든 평가 항목 조회
const getGridData = async () => {
  let param = {
    memberCode: checkUserId.value.memberCode,
  };
  await store.dispatch("grid/fetchAllDomain", param);
};

const getEvlData = async () => {
  let param = {
    organizationCode: orgCode.value,
    orgGiasYear : '2025'
  };
  //await store.dispatch("grid/fetchAdminEvlOrg2", param); fetchSelectGiasWeight
  await store.dispatch("grid/fetchSelectIMSWeight", param);
};


let orgName = ref('')
let orgCode = ref('')

onMounted(async () => {
  orgName.value = route.query?.organizationName || ''; 
  orgCode.value = route.query?.organizationCode || ''; 

  //console.log("기관이름" + orgName.value )
  await getGridData(); //메인 그리드 평가항목리스트
  await getEvlData(); // 평가항목에 저장된 점수를 조회
  // await getEvl3Year(); // 3년치 평가 점수 평균 데이터
  // await getGiasAvg();  // 모든 기업의 전체 통계 요약
  // await getGiasAllAvg(); // 기업별 통계 요약
});

// 컴포넌트 언마운트 시 호출
onUnmounted(() => {
  // Store의 clearEvlOrgData를 호출
  store.commit("grid/clearEvlOrgData2");
})

// (도우미) 셀 스타일/값 복사
const copyCell = (srcCell, destCell) => {
  destCell.value = srcCell.value;
  if (srcCell.font) destCell.font = { ...srcCell.font };
  if (srcCell.alignment) destCell.alignment = { ...srcCell.alignment };
  if (srcCell.border) destCell.border = JSON.parse(JSON.stringify(srcCell.border));
  if (srcCell.fill) destCell.fill = JSON.parse(JSON.stringify(srcCell.fill));
  if (srcCell.numFmt) destCell.numFmt = srcCell.numFmt;
  if (srcCell.protection) destCell.protection = { ...srcCell.protection };
};

// (도우미) 행 높이 복사
const copyRowHeight = (srcRow, destRow) => {
  if (srcRow.height) destRow.height = srcRow.height;
};

// (도우미) 병합 안전 수행: 기존 병합 있으면 먼저 해제 후 병합
const safeMerge = (ws, r1, c1, r2, c2) => {
  try { ws.unMergeCells(r1, c1, r2, c2); } catch (_) {}
  try { ws.mergeCells(r1, c1, r2, c2); } catch (_) {}
};


// standard 단위로 {code, name, evals:[{code,name}...]} 목록 만들기
// 표준(standard) 단위로 {code, name, evals:[{code,name,score,weight,weightedPoint}...]}
const getStandardsWithEvaluations = () => {
  const stdMap = new Map(); // standardCode -> { code, name, evals: Map }

  for (const d of transformedDomains.value) {
    for (const p of d.principles) {
      for (const s of p.standards) {
        const sc = s.standardCode;
        if (!sc) continue;
        if (!stdMap.has(sc)) {
          stdMap.set(sc, { code: sc, name: s.standardName ?? '', evals: new Map() });
        } else if (!stdMap.get(sc).name && s.standardName) {
          stdMap.get(sc).name = s.standardName;
        }

        for (const e of s.evaluations || []) {
          const ec = e.evaluationCode;
          if (!ec) continue;
          const incoming = {
            code: ec,
            name: e.evaluationName ?? '',
            score: e.evaluationScore ?? null,
            weight: e.evaluationWeight ?? null,
            weightedPoint: e.weightedPoint ?? null,
            // ⬇ 문자열(강점/약점)들
            approachStr:    e.approachStr ?? '',
            deploymentStr:  e.deploymentStr ?? '',
            monitotingStr:  e.monitotingStr ?? '',   // ← 스펠링 원문 유지
            actionStr:      e.actionStr ?? '',
            approachWeak:   e.approachWeak ?? '',
            deploymentWeak: e.deploymentWeak ?? '',
            monitotingWeak: e.monitotingWeak ?? '',  // ← 스펠링 원문 유지
            actionWeak:     e.actionWeak ?? '',
          };
          if (!stdMap.get(sc).evals.has(ec)) {
            stdMap.get(sc).evals.set(ec, incoming);
          } else {
            const cur = stdMap.get(sc).evals.get(ec);
            if (!cur.name && incoming.name) cur.name = incoming.name;
            if (cur.score == null && incoming.score != null) cur.score = incoming.score;
            if (cur.weight == null && incoming.weight != null) cur.weight = incoming.weight;
            if (cur.weightedPoint == null && incoming.weightedPoint != null) {
              cur.weightedPoint = incoming.weightedPoint;
            }
            // 문자열 필드는 비어있을 때만 채움
            if (!cur.approachStr && incoming.approachStr) cur.approachStr = incoming.approachStr;
            if (!cur.deploymentStr && incoming.deploymentStr) cur.deploymentStr = incoming.deploymentStr;
            if (!cur.monitotingStr && incoming.monitotingStr) cur.monitotingStr = incoming.monitotingStr;
            if (!cur.actionStr && incoming.actionStr) cur.actionStr = incoming.actionStr;
            if (!cur.approachWeak && incoming.approachWeak) cur.approachWeak = incoming.approachWeak;
            if (!cur.deploymentWeak && incoming.deploymentWeak) cur.deploymentWeak = incoming.deploymentWeak;
            if (!cur.monitotingWeak && incoming.monitotingWeak) cur.monitotingWeak = incoming.monitotingWeak;
            if (!cur.actionWeak && incoming.actionWeak) cur.actionWeak = incoming.actionWeak;
          }
        }
      }
    }
  }

  const arr = Array.from(stdMap.values()).map(v => ({
    code: v.code,
    name: v.name,
    evals: Array.from(v.evals.values()),
  }));
  arr.sort((a, b) => String(a.code).localeCompare(String(b.code), undefined, { numeric: true }));
  return arr;
};

/** 트리 -> {code, name, approach, deployment, monitoringProcess, action} 유일화 */
const getEvalPairsFromTreeUnique = () => {
  const map = new Map(); // code -> pair
  for (const d of transformedDomains.value) {
    for (const p of d.principles) {
      for (const s of p.standards) {
        for (const e of s.evaluations) {
          const code = e.evaluationCode;
          if (!code) continue; // 코드 없으면 스킵

          const incoming = {
            code,
            name: e.evaluationName ?? '',
            approach: e.approach ?? '',
            deployment: e.deployment ?? '',
            monitoringProcess: e.monitoringProcess ?? '',
            action: e.action ?? '',
            approachScore: e.approachScore ?? '',
            deploymentScore: e.deploymentScore ?? '',
            monitoringScore: e.monitoringScore ?? '',
            actionScore: e.actionScore ?? '',
            evaluationScore : e.evaluationScore ?? '',
            approachStr : e.approachStr ?? '',
            deploymentStr : e.deploymentStr ?? '',
            monitotingStr : e.monitotingStr ?? '',
            actionStr : e.actionStr ?? '',
            approachWeak : e.approachWeak ?? '',
            deploymentWeak : e.deploymentWeak ?? '',
            monitotingWeak : e.monitotingWeak ?? '',
            actionWeak : e.actionWeak ?? '',
          };

          if (!map.has(code)) {
            map.set(code, incoming);
          } else {
            // 이미 있는 항목의 빈 칸만 보충
            const cur = map.get(code);
            if (!cur.name && incoming.name) cur.name = incoming.name;
            if (!cur.approach && incoming.approach) cur.approach = incoming.approach;
            if (!cur.deployment && incoming.deployment) cur.deployment = incoming.deployment;
            if (!cur.monitoringProcess && incoming.monitoringProcess) cur.monitoringProcess = incoming.monitoringProcess;
            if (!cur.action && incoming.action) cur.action = incoming.action;
            if (!cur.approachScore && incoming.approachScore) cur.approachScore = incoming.approachScore;
            if (!cur.deploymentScore && incoming.deploymentScore) cur.deploymentScore = incoming.deploymentScore;
            if (!cur.monitoringScore && incoming.monitoringScore) cur.monitoringScore = incoming.monitoringScore;
            if (!cur.actionScore && incoming.actionScore) cur.actionScore = incoming.actionScore;
            if (!cur.evaluationScore && incoming.evaluationScore) cur.evaluationScore = incoming.evaluationScore;

            if (!cur.approachStr && incoming.approachStr) cur.approachStr = incoming.approachStr;
            if (!cur.deploymentStr && incoming.deploymentStr) cur.deploymentStr = incoming.deploymentStr;
            if (!cur.monitotingStr && incoming.monitotingStr) cur.monitotingStr = incoming.monitotingStr;
            if (!cur.actionStr && incoming.actionStr) cur.actionStr = incoming.actionStr;

            if (!cur.approachWeak && incoming.approachWeak) cur.approachWeak = incoming.approachWeak;
            if (!cur.deploymentWeak && incoming.deploymentWeak) cur.deploymentWeak = incoming.deploymentWeak;
            if (!cur.monitotingWeak && incoming.monitotingWeak) cur.monitotingWeak = incoming.monitotingWeak;
            if (!cur.actionWeak && incoming.actionWeak) cur.actionWeak = incoming.actionWeak;
            
          }
        }
      }
    }
  }

  // 필요 시 정렬(코드에 숫자 있음 가정, 자연정렬 느낌)
  const arr = Array.from(map.values());
  arr.sort((a, b) => String(a.code).localeCompare(String(b.code), undefined, { numeric: true }));
  return arr;
};




/* ────────────────────────────── 통합 다운로드 ────────────────────────────── */
const downloadExcelAll = async () => {
  // 템플릿 1번만 로드
  const res = await fetch(encodeURI('/files/test_excel.xlsx'));
  if (!res.ok) { console.error('템플릿을 불러오지 못했습니다:', res.status); return; }
  const ab = await res.arrayBuffer();

  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(ab);
  wb.calcProperties.fullCalcOnLoad = true;

  /* ===================== [Lv.2(발행)] ===================== */
  (function fillLv2() {
    const ws = wb.getWorksheet('Lv.2');
    if (!ws) { console.error('시트 "Lv.2(발행)"를 찾을 수 없습니다.'); return; }

    // (도메인, 프린서펄) 스코프로 표준 묶기
    const getPrinciplesWithStandardsStrict = () => {
      const map = new Map(); // key = `${domainCode}::${principleCode}`
      for (const r of (orgEvlList.value || [])) {
        const d = r.domainCode, p = r.principleCode;
        if (!d || !p) continue;
        const key = `${d}::${p}`;
        if (!map.has(key)) {
          map.set(key, {
            domainCode: d,
            domainName: r.domainName || '',
            principleCode: p,
            principleName: r.principleName || '',
            tacticalOrganizationalObjectives1002d: r.tacticalOrganizationalObjectives1002d ?? '',
            standards: new Map(), // standardCode -> { ... }
          });
        }
        const bucket = map.get(key).standards;
        const s = r.standardCode;
        if (s && !bucket.has(s)) {
          bucket.set(s, {
            code: s,
            name: r.standardName || '',
            controlObjectiveRating2d:      r.controlObjectiveRating2d || 0,
            weightedControlObjective2d:    r.weightedControlObjective2d || 0,
            standardWeight:                r.standardWeight ?? '',
          });
        } else if (s) {
          const cur = bucket.get(s);
          if (cur && !cur.name && r.standardName) cur.name = r.standardName;
        }
      }
      const arr = Array.from(map.values()).map(x => ({
        ...x,
        standards: Array.from(x.standards.values())
          .sort((a,b)=>String(a.code).localeCompare(String(b.code), undefined, { numeric:true })),
      }));
      return arr;
    };

    // 프린서펄 단위 평가(강/약점) 수집
    const buildUniqueEvalsForPrinciple = (domainCode, principleCode) => {
      const m = new Map(); // evaluationCode -> aggregated fields
      for (const r of (orgEvlList.value || [])) {
        if (r.domainCode !== domainCode || r.principleCode !== principleCode) continue;
        const code = r.evaluationCode;
        if (!code) continue;

        const incoming = {
          code,
          approachStr:    r.approachStr ?? '',
          deploymentStr:  r.deploymentStr ?? '',
          monitotingStr:  r.monitotingStr ?? '',
          actionStr:      r.actionStr ?? '',
          approachWeak:   r.approachWeak ?? '',
          deploymentWeak: r.deploymentWeak ?? '',
          monitotingWeak: r.monitotingWeak ?? '',
          actionWeak:     r.actionWeak ?? '',
        };

        if (!m.has(code)) {
          m.set(code, incoming);
        } else {
          const cur = m.get(code);
          for (const k of Object.keys(incoming)) {
            if (k === 'code') continue;
            if ((!cur[k] || String(cur[k]).trim() === '') && incoming[k]) cur[k] = incoming[k];
          }
        }
      }
      return Array.from(m.values())
        .sort((a,b)=>String(a.code).localeCompare(String(b.code), undefined, { numeric:true }));
    };

    // 여러 키의 텍스트를 평가코드별로 묶어 하나의 블록으로
    const combineByKeys = (evals, keys) => {
      const lines = [];
      for (const ev of evals) {
        const chunks = [];
        for (const k of keys) {
          const t = ev[k];
          if (t && String(t).trim()) chunks.push(String(t).trim());
        }
        if (chunks.length) lines.push(`${ev.code ? ev.code + ': ' : ''}${chunks.join('\n')}`);
      }
      return lines.join('\n\n');
    };

    const SRC = { sr: 1, er: 10, sc: 1, ec: 5 }; // A1:E10
    const baseBlockHeight = SRC.er - SRC.sr + 1; // 10
    const gapRows = 1;

    const topMerges = [
      { r1: 1, c1: 2, r2: 1, c2: 5 }, // B1:E1
      { r1: 2, c1: 2, r2: 2, c2: 5 }, // B2:E2
      { r1: 3, c1: 2, r2: 3, c2: 5 }, // B3:E3 (강점)
      { r1: 4, c1: 2, r2: 4, c2: 5 }, // B4:E4 (약점)
      { r1: 5, c1: 1, r2: 5, c2: 5 }, // A5:E5
      { r1: 8, c1: 1, r2: 8, c2: 2 }, // A8:B8
    ];
    const bottomMergeAnchors = [
      { off: 9 - SRC.sr, c1: 1, c2: 5 }, // A9:E9  (표 아래 고정)
    ];

    // 템플릿 스냅샷(값/스타일/행높이)
    const snapshot = [];
    for (let r = 0; r < baseBlockHeight; r++) {
      const sRow = ws.getRow(SRC.sr + r);
      const rowSnap = { height: sRow.height || undefined, cells: [] };
      for (let c = 0; c <= (SRC.ec - SRC.sc); c++) {
        const sCell = ws.getCell(SRC.sr + r, SRC.sc + c);
        rowSnap.cells.push({
          value: sCell.value,
          font: sCell.font ? { ...sCell.font } : undefined,
          alignment: sCell.alignment ? { ...sCell.alignment } : undefined,
          border: sCell.border ? JSON.parse(JSON.stringify(sCell.border)) : undefined,
          fill: sCell.fill ? JSON.parse(JSON.stringify(sCell.fill)) : undefined,
          numFmt: sCell.numFmt || undefined,
          protection: sCell.protection ? { ...sCell.protection } : undefined,
        });
      }
      snapshot.push(rowSnap);
    }
    const pasteSnapshot = (destStartRow) => {
      for (let r = 0; r < snapshot.length; r++) {
        const dRow = ws.getRow(destStartRow + r);
        if (snapshot[r].height) dRow.height = snapshot[r].height;
        for (let c = 0; c < snapshot[r].cells.length; c++) {
          const snap = snapshot[r].cells[c];
          const dCell = ws.getCell(destStartRow + r, SRC.sc + c);
          dCell.value = snap.value;
          if (snap.font) dCell.font = { ...snap.font };
          if (snap.alignment) dCell.alignment = { ...snap.alignment };
          if (snap.border) dCell.border = JSON.parse(JSON.stringify(snap.border));
          if (snap.fill) dCell.fill = JSON.parse(JSON.stringify(snap.fill));
          if (snap.numFmt) dCell.numFmt = snap.numFmt;
          if (snap.protection) dCell.protection = { ...snap.protection };
        }
      }
    };

    const OFF = {
      principleCode: { row: 1 - SRC.sr, col: 2 }, // B1
      principleName: { row: 2 - SRC.sr, col: 2 }, // B2
      strengths:     { row: 3 - SRC.sr, col: 2 }, // B3
      weaknesses:    { row: 4 - SRC.sr, col: 2 }, // B4
      stdRowBase:    7 - SRC.sr,                  // A7~
      stdCodeCol:    1,                            // A
      stdNameCol:    2,                            // B
    };

    const writeTextAt = (absRow, absCol, v, wrap = true) => {
      const cell = ws.getCell(absRow, absCol);
      cell.value = v ?? '';
      cell.alignment = { wrapText: !!wrap, horizontal: 'left', vertical: 'top' };
    };
    const writeNumAt = (absRow, absCol, v, fmt = '0.0') => {
      const cell = ws.getCell(absRow, absCol);
      const n = Number(v);
      if (v === '' || v == null || isNaN(n)) {
        cell.value = '';
      } else {
        cell.value = n;
        cell.numFmt = fmt;
      }
      cell.alignment = { horizontal: 'right', vertical: 'middle' };
    };

    const principles = getPrinciplesWithStandardsStrict();
    if (!principles.length) {
      console.warn('Lv.2에 매핑할 프린서펄 데이터가 없습니다.');
      return;
    }

    let cur = SRC.sr;
    for (let i = 0; i < principles.length; i++) {
      const p = principles[i];
      const stds = (p.standards?.length
        ? p.standards
        : [{ code: '', name: '', controlObjectiveRating2d: '', weightedControlObjective2d: '', standardWeight: '' }]);
      const addRows = stds.length - 1;

      // 1) 템플릿 블록 붙이기
      pasteSnapshot(cur);

      // 2) 상단 병합
      topMerges.forEach(m => {
        const r1 = cur + (m.r1 - SRC.sr);
        const r2 = cur + (m.r2 - SRC.sr);
        safeMerge(ws, r1, m.c1, r2, m.c2);
      });

      // 3) 헤더 및 강/약점
      writeTextAt(cur + OFF.principleCode.row, OFF.principleCode.col, p.principleCode, false);
      writeTextAt(cur + OFF.principleName.row, OFF.principleName.col, p.principleName, true);

      const evalsForP = buildUniqueEvalsForPrinciple(p.domainCode, p.principleCode);
      const strengths = combineByKeys(evalsForP, ['approachStr','deploymentStr','monitotingStr','actionStr']);
      const weaknesses = combineByKeys(evalsForP, ['approachWeak','deploymentWeak','monitotingWeak','actionWeak']);
      writeTextAt(cur + OFF.strengths.row,  OFF.strengths.col,  strengths,  true); // B3:E3 (병합됨)
      writeTextAt(cur + OFF.weaknesses.row, OFF.weaknesses.col, weaknesses, true); // B4:E4 (병합됨)

      // 4) 표준행(A7~) 확장 + 값 매핑
      const firstStdRow = cur + OFF.stdRowBase;

      for (let c = 1; c <= 5; c++) ws.getCell(firstStdRow, c).value = null; // 초기 행 비우기
      if (addRows > 0) ws.duplicateRow(firstStdRow, addRows, true);

      for (let k = 0; k < stds.length; k++) {
        const r = firstStdRow + k;
        for (let c = 1; c <= 5; c++) ws.getCell(r, c).value = ws.getCell(r, c).value ?? null;

        writeTextAt(r, OFF.stdCodeCol, stds[k].code, false);  // A
        writeTextAt(r, OFF.stdNameCol, stds[k].name, true);   // B

        // C,D,E = controlObjectiveRating2d, standardWeight, weightedControlObjective2d
        writeNumAt(r, 3, stds[k].controlObjectiveRating2d,   '0.0'); // C
        writeNumAt(r, 4, stds[k].standardWeight,             '0.0'); // D
        writeNumAt(r, 5, stds[k].weightedControlObjective2d, '0.0'); // E
      }

      // 5) 고정 하단 병합 (확장 반영)
      bottomMergeAnchors.forEach(({ off, c1, c2 }) => {
        const row = cur + off + addRows;
        safeMerge(ws, row, c1, row, c2);
      });

      // 6) 합계 (표준 마지막행 바로 아래)
      const lastStdRow = firstStdRow + (stds.length - 1);
      const sumRow     = lastStdRow + 1;

      try { ws.unMergeCells(sumRow, 3, sumRow, 5); } catch (_) {}

      const cTotal = ws.getCell(sumRow, 3);
      const dTotal = ws.getCell(sumRow, 4);
      const eTotal = ws.getCell(sumRow, 5);
      cTotal.value = { formula: `SUM(C${firstStdRow}:C${lastStdRow})` };
      dTotal.value = { formula: `SUM(D${firstStdRow}:D${lastStdRow})` };
      eTotal.value = { formula: `SUM(E${firstStdRow}:E${lastStdRow})` };
      [cTotal, dTotal, eTotal].forEach(c => { c.numFmt = '0.0'; c.alignment = { horizontal: 'right', vertical: 'middle' }; });

      // 합계행: A:B 병합
      safeMerge(ws, sumRow, 1, sumRow, 2);

      // 7) 합계행 + 2행 아래: B:E 병합 + B에 tacticalOrganizationalObjectives1002d 매핑
      const after2 = sumRow + 2;
      safeMerge(ws, after2, 2, after2, 5);
      const too = p.tacticalOrganizationalObjectives1002d;
      if (too !== '' && too !== null && !isNaN(Number(too))) {
        const bCell = ws.getCell(after2, 2);
        bCell.value = Number(too);
        bCell.numFmt = '0.0';
        bCell.alignment = { horizontal: 'right', vertical: 'middle' };
      } else {
        writeTextAt(after2, 2, (too ?? '').toString(), true);
      }

      // 8) 다음 블록 위치
      const nextStart = cur + baseBlockHeight + addRows + gapRows;
      cur = nextStart;
      if (gapRows > 0) {
        const gapRow = ws.getRow(cur - 1);
        gapRow.height = gapRow.height || 6;
      }
    }
  })();

  /* ===================== [Lv.4] ===================== */
  (function fillLv4() {
    const ws4 = wb.getWorksheet('Lv.4');
    if (!ws4) { console.error('시트 "Lv.4"를 찾을 수 없습니다.'); return; }

    const SRC4 = { sr: 2, er: 18, sc: 1, ec: 4 };
    const blockHeight4 = SRC4.er - SRC4.sr + 1;
    const gapRows4 = 1;

    const merges4 = [
      { r1: 2,  c1: 2, r2: 2,  c2: 4 }, // B2:D2
      { r1: 3,  c1: 2, r2: 3,  c2: 4 }, // B3:D3
      { r1: 4,  c1: 1, r2: 7,  c2: 1 }, // A4:A7
      { r1: 8,  c1: 1, r2: 11, c2: 1 }, // A8:A11
      { r1: 12, c1: 1, r2: 12, c2: 4 }, // A12:D12
      // 강점 텍스트
      { r1: 4,  c1: 3, r2: 4,  c2: 4 },
      { r1: 5,  c1: 3, r2: 5,  c2: 4 },
      { r1: 6,  c1: 3, r2: 6,  c2: 4 },
      { r1: 7,  c1: 3, r2: 7,  c2: 4 },
      // 약점 텍스트
      { r1: 8,  c1: 3, r2: 8,  c2: 4 },
      { r1: 9,  c1: 3, r2: 9,  c2: 4 },
      { r1: 10, c1: 3, r2: 10, c2: 4 },
      { r1: 11, c1: 3, r2: 11, c2: 4 },
    ];

    const copyBlock4 = (destStartRow, doMerge = true) => {
      for (let r = 0; r < blockHeight4; r++) {
        const srcRow = ws4.getRow(SRC4.sr + r);
        const dstRow = ws4.getRow(destStartRow + r);
        copyRowHeight(srcRow, dstRow);
        for (let c = 0; c <= (SRC4.ec - SRC4.sc); c++) {
          const srcCell  = ws4.getCell(SRC4.sr + r, SRC4.sc + c);
          const destCell = ws4.getCell(destStartRow + r, SRC4.sc + c);
          copyCell(srcCell, destCell);
        }
      }
      if (doMerge) {
        merges4.forEach(m => {
          const r1 = destStartRow + (m.r1 - SRC4.sr);
          const r2 = destStartRow + (m.r2 - SRC4.sr);
          safeMerge(ws4, r1, m.c1, r2, m.c2);
        });
      }
    };

    const OFF4 = {
      code:           { row: 2 - SRC4.sr,  col: 2 },
      name:           { row: 3 - SRC4.sr,  col: 2 },
      approachStr:    { row: 4 - SRC4.sr,  col: 3 },
      deploymentStr:  { row: 5 - SRC4.sr,  col: 3 },
      monitotingStr:  { row: 6 - SRC4.sr,  col: 3 },
      actionStr:      { row: 7 - SRC4.sr,  col: 3 },
      approachWeak:   { row: 8 - SRC4.sr,  col: 3 },
      deploymentWeak: { row: 9 - SRC4.sr,  col: 3 },
      monitotingWeak: { row: 10 - SRC4.sr, col: 3 },
      actionWeak:     { row: 11 - SRC4.sr, col: 3 },
      approachSc:     { row: 14 - SRC4.sr, col: 3 },
      deploySc:       { row: 15 - SRC4.sr, col: 3 },
      monitorSc:      { row: 16 - SRC4.sr, col: 3 },
      actionSc:       { row: 17 - SRC4.sr, col: 3 },
      evalSc:         { row: 18 - SRC4.sr, col: 3 },
    };

    const writeAny4 = (destStartRow, off, v, numFmt) => {
      const cell = ws4.getCell(destStartRow + off.row, off.col);
      const isNum = v !== '' && v !== null && v !== undefined && !isNaN(Number(v));
      cell.value = isNum ? Number(v) : (v ?? '');
      cell.alignment = { wrapText: true, horizontal: 'left', vertical: 'middle' };
      if (isNum && numFmt) cell.numFmt = numFmt;
    };

    const pairs = getEvalPairsFromTreeUnique();
    for (let i = 0; i < pairs.length; i++) {
      const destStartRow = SRC4.sr + i * (blockHeight4 + gapRows4);
      copyBlock4(destStartRow, i !== 0);

      writeAny4(destStartRow, OFF4.code,           pairs[i].code);
      writeAny4(destStartRow, OFF4.name,           pairs[i].name);
      writeAny4(destStartRow, OFF4.approachStr,    pairs[i].approachStr);
      writeAny4(destStartRow, OFF4.deploymentStr,  pairs[i].deploymentStr);
      writeAny4(destStartRow, OFF4.monitotingStr,  pairs[i].monitotingStr);
      writeAny4(destStartRow, OFF4.actionStr,      pairs[i].actionStr);
      writeAny4(destStartRow, OFF4.approachWeak,   pairs[i].approachWeak);
      writeAny4(destStartRow, OFF4.deploymentWeak, pairs[i].deploymentWeak);
      writeAny4(destStartRow, OFF4.monitotingWeak, pairs[i].monitotingWeak);
      writeAny4(destStartRow, OFF4.actionWeak,     pairs[i].actionWeak);

      writeAny4(destStartRow, OFF4.approachSc,     pairs[i].approachScore,   '0.0');
      writeAny4(destStartRow, OFF4.deploySc,       pairs[i].deploymentScore, '0.0');
      writeAny4(destStartRow, OFF4.monitorSc,      pairs[i].monitoringScore, '0.0');
      writeAny4(destStartRow, OFF4.actionSc,       pairs[i].actionScore,     '0.0');
      writeAny4(destStartRow, OFF4.evalSc,         pairs[i].evaluationScore, '0.0');
    }
  })();

  /* ===================== [Lv.3] ===================== */
  (function fillLv3() {
    const ws3 = wb.getWorksheet('Lv.3');
    if (!ws3) { console.error('시트 "Lv.3"를 찾을 수 없습니다.'); return; }

    const SRC3 = { sr: 2, er: 16, sc: 1, ec: 7 };
    const baseBlockHeight3 = SRC3.er - SRC3.sr + 1; // 15
    const gapRows3 = 1;

    const staticMerges3 = [
      { r1: 2,  c1: 2, r2: 2,  c2: 7 }, // B2:G2
      { r1: 3,  c1: 2, r2: 3,  c2: 7 }, // B3:G3
      { r1: 4,  c1: 1, r2: 7,  c2: 1 }, // A4:A7
      { r1: 8,  c1: 1, r2: 11, c2: 1 }, // A8:A11
      { r1: 12, c1: 1, r2: 12, c2: 7 }, // A12:G12
      { r1: 13, c1: 1, r2: 13, c2: 7 }, // A13:G13
      { r1: 14, c1: 2, r2: 14, c2: 4 }, // B14:D14
      { r1: 4,  c1: 3, r2: 4,  c2: 7 }, // C4:G4
      { r1: 5,  c1: 3, r2: 5,  c2: 7 },
      { r1: 6,  c1: 3, r2: 6,  c2: 7 },
      { r1: 7,  c1: 3, r2: 7,  c2: 7 },
      { r1: 8,  c1: 3, r2: 8,  c2: 7 },
      { r1: 9,  c1: 3, r2: 9,  c2: 7 },
      { r1: 10, c1: 3, r2: 10, c2: 7 },
      { r1: 11, c1: 3, r2: 11, c2: 7 },
    ];

    const copyBlockStatic3 = (destStartRow, doMerge = true) => {
      for (let r = 0; r < baseBlockHeight3; r++) {
        const srcRow = ws3.getRow(SRC3.sr + r);
        const dstRow = ws3.getRow(destStartRow + r);
        copyRowHeight(srcRow, dstRow);
        for (let c = 0; c <= (SRC3.ec - SRC3.sc); c++) {
          const srcCell  = ws3.getCell(SRC3.sr + r, SRC3.sc + c);
          const destCell = ws3.getCell(destStartRow + r, SRC3.sc + c);
          copyCell(srcCell, destCell);
        }
      }
      if (doMerge) {
        staticMerges3.forEach(m => {
          const r1 = destStartRow + (m.r1 - SRC3.sr);
          const r2 = destStartRow + (m.r2 - SRC3.sr);
          safeMerge(ws3, r1, m.c1, r2, m.c2);
        });
      }
    };

    const OFF3 = {
      standardCode:   { row: 2 - SRC3.sr,  col: 2 },
      standardName:   { row: 3 - SRC3.sr,  col: 2 },
      approachStr:    { row: 4 - SRC3.sr,  col: 3 },
      deploymentStr:  { row: 5 - SRC3.sr,  col: 3 },
      monitotingStr:  { row: 6 - SRC3.sr,  col: 3 },
      actionStr:      { row: 7 - SRC3.sr,  col: 3 },
      approachWeak:   { row: 8 - SRC3.sr,  col: 3 },
      deploymentWeak: { row: 9 - SRC3.sr,  col: 3 },
      monitotingWeak: { row: 10 - SRC3.sr, col: 3 },
      actionWeak:     { row: 11 - SRC3.sr, col: 3 },
      evalRowBase:    15 - SRC3.sr,
      evalCodeCol:    1,
      evalNameCol:    2,
      footerRowBase:  16 - SRC3.sr,
    };

    const writeText3 = (row, col, v) => {
      const cell = ws3.getCell(row, col);
      cell.value = v ?? '';
      cell.alignment = { wrapText: true, horizontal: 'left', vertical: 'top' };
    };
    const writeNum3 = (row, col, v, fmt = '0.0') => {
      const cell = ws3.getCell(row, col);
      if (v === '' || v == null || isNaN(Number(v))) cell.value = '';
      else { cell.value = Number(v); cell.numFmt = fmt; }
      cell.alignment = { horizontal: 'right', vertical: 'middle' };
    };
    const combineField3 = (evals, key) => {
      const lines = [];
      for (const ev of evals) {
        const txt = ev[key];
        if (txt && String(txt).trim()) {
          const code = ev.code ? String(ev.code).trim() : '';
          lines.push(code ? `${code}: ${String(txt).trim()}` : String(txt).trim());
        }
      }
      return lines.join('\n\n');
    };

    const standards = getStandardsWithEvaluations(); // [{code,name,evals:[]}]
    let cur3 = SRC3.sr;

    for (let i = 0; i < standards.length; i++) {
      const std = standards[i];
      const evals = (std.evals?.length ? std.evals : [{ code: '', name: '', score: null, weight: null, weightedPoint: null }]);
      const evalCount = Math.max(evals.length, 1);

      copyBlockStatic3(cur3, i !== 0);
      writeText3(cur3 + OFF3.standardCode.row, OFF3.standardCode.col, std.code);
      writeText3(cur3 + OFF3.standardName.row, OFF3.standardName.col, std.name);

      writeText3(cur3 + OFF3.approachStr.row,    OFF3.approachStr.col,    combineField3(evals, 'approachStr'));
      writeText3(cur3 + OFF3.deploymentStr.row,  OFF3.deploymentStr.col,  combineField3(evals, 'deploymentStr'));
      writeText3(cur3 + OFF3.monitotingStr.row,  OFF3.monitotingStr.col,  combineField3(evals, 'monitotingStr'));
      writeText3(cur3 + OFF3.actionStr.row,      OFF3.actionStr.col,      combineField3(evals, 'actionStr'));
      writeText3(cur3 + OFF3.approachWeak.row,   OFF3.approachWeak.col,   combineField3(evals, 'approachWeak'));
      writeText3(cur3 + OFF3.deploymentWeak.row, OFF3.deploymentWeak.col, combineField3(evals, 'deploymentWeak'));
      writeText3(cur3 + OFF3.monitotingWeak.row, OFF3.monitotingWeak.col, combineField3(evals, 'monitotingWeak'));
      writeText3(cur3 + OFF3.actionWeak.row,     OFF3.actionWeak.col,     combineField3(evals, 'actionWeak'));

      const firstEvalRow = cur3 + OFF3.evalRowBase;
      if (evalCount > 1) ws3.duplicateRow(firstEvalRow, evalCount - 1, true);

      for (let k = 0; k < evalCount; k++) {
        const r = firstEvalRow + k;
        safeMerge(ws3, r, 2, r, 4); // B:D
        const ev = evals[k] || {};
        writeText3(r, OFF3.evalCodeCol, ev.code);
        writeText3(r, OFF3.evalNameCol, ev.name);
        writeNum3(r, 5, ev.score, '0.0');          // E
        writeNum3(r, 6, ev.weight, '0.0');         // F
        writeNum3(r, 7, ev.weightedPoint, '0.0');  // G
      }

      const footerRow = cur3 + OFF3.footerRowBase + (evalCount - 1);
      safeMerge(ws3, footerRow, 1, footerRow, 4);
      const sumStart = firstEvalRow;
      const sumEnd   = firstEvalRow + evalCount - 1;
      const eTotal = ws3.getCell(footerRow, 5);
      const fTotal = ws3.getCell(footerRow, 6);
      const gTotal = ws3.getCell(footerRow, 7);
      eTotal.value = { formula: `SUM(E${sumStart}:E${sumEnd})` };
      fTotal.value = { formula: `SUM(F${sumStart}:F${sumEnd})` };
      gTotal.value = { formula: `SUM(G${sumStart}:G${sumEnd})` };
      [eTotal, fTotal, gTotal].forEach(c => { c.numFmt = '0.0'; c.alignment = { horizontal: 'right', vertical: 'middle' }; });

      cur3 = cur3 + baseBlockHeight3 + (evalCount - 1) + gapRows3;
      if (gapRows3 > 0) {
        const gapRow = ws3.getRow(cur3 - 1);
        gapRow.height = gapRow.height || 6;
      }
    }
  })();

  // 저장 (Lv2+Lv3+Lv4)
  const fileName = `${(orgName?.value || 'organization')}_통합_${(selectedYear?.value || new Date().getFullYear())}.xlsx`;
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, fileName);
};

// /files/LV4.Doumentation_템플릿.xlsx 를 읽어 Lv.4 시트에 값/병합 적용 후 저장
const downloadExcel_2 = async () => {
  const pairs = getEvalPairsFromTreeUnique(); // [{code,name,approach,deployment,monitoringProcess,action,...}]
  if (!pairs.length) {
    console.warn('반복할 평가 항목이 없습니다.');
    return;
  }
  console.log(pairs.length)
  const res = await fetch(encodeURI('/files/LV4.Doumentation_템플릿.xlsx'));
  if (!res.ok) {
    console.error('템플릿을 불러오지 못했습니다:', res.status);
    return;
  }
  const ab = await res.arrayBuffer();

  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(ab);
  const ws = wb.getWorksheet('LV4');
  if (!ws) {
    console.error("시트 'Lv.4'를 찾을 수 없습니다.");
    return;
  }

  // 원본 블록(A1:D9)
  const SRC = { sr: 1, er: 9, sc: 1, ec: 4 }; // 1-indexed
  const blockHeight = SRC.er - SRC.sr + 1;    // 9
  const gapRows = 1;                           // ⬅ 블록 사이 1행 간격 추가

  // 블록 내부 병합(템플릿 절대 좌표) — 첫 블록 재병합 스킵
  const merges = [
    { r1: 2, c1: 2, r2: 2, c2: 4 }, // B2:D2  (code 라벨 구간과 별개, 템플릿 유지)
    { r1: 3, c1: 1, r2: 3, c2: 4 }, // A3:D3  ← approach
    { r1: 5, c1: 1, r2: 5, c2: 4 }, // A5:D5  ← deployment
    { r1: 7, c1: 1, r2: 7, c2: 4 }, // A7:D7  ← monitoringProcess
    { r1: 9, c1: 1, r2: 9, c2: 4 }, // A9:D9  ← action
  ];

  const copyBlock = (destStartRow, doMerge = true) => {
    for (let r = 0; r < blockHeight; r++) {
      const srcRow = ws.getRow(SRC.sr + r);
      const dstRow = ws.getRow(destStartRow + r);
      copyRowHeight(srcRow, dstRow);
      for (let c = 0; c <= (SRC.ec - SRC.sc); c++) {
        const srcCell  = ws.getCell(SRC.sr + r, SRC.sc + c);
        const destCell = ws.getCell(destStartRow + r, SRC.sc + c);
        copyCell(srcCell, destCell);
      }
    }
    if (doMerge) {
      merges.forEach(m => {
        const r1 = destStartRow + (m.r1 - SRC.sr);
        const r2 = destStartRow + (m.r2 - SRC.sr);
        const c1 = m.c1, c2 = m.c2;
        safeMerge(ws, r1, c1, r2, c2);
      });
    }
  };

  // 블록 내 상대 좌표 (SRC 기준)
  const OFF = {
    code:       { row: 1 - SRC.sr, col: 2 }, // B1
    name:       { row: 1 - SRC.sr, col: 4 }, // D1
    approach:   { row: 3 - SRC.sr, col: 1 }, // A3 (A3:D3 병합영역의 첫셀)
    deployment: { row: 5 - SRC.sr, col: 1 }, // A5 (A5:D5)
    monitor:    { row: 7 - SRC.sr, col: 1 }, // A7 (A7:D7)
    action:     { row: 9 - SRC.sr, col: 1 }, // A9 (A9:D9)
  };

  const writeText = (destStartRow, off, v) => {
    const cell = ws.getCell(destStartRow + off.row, off.col);
    cell.value = v ?? '';
    cell.alignment = { wrapText: true, horizontal: 'left', vertical: 'middle' };
  };

  for (let i = 0; i < pairs.length; i++) {
    const destStartRow = SRC.sr + i * (blockHeight + gapRows);

    // 블록 복제 (첫 블록 병합 스킵)
    copyBlock(destStartRow, i !== 0);

    // 값 매핑
    writeText(destStartRow, OFF.code,       pairs[i].code);
    writeText(destStartRow, OFF.name,       pairs[i].name);
    writeText(destStartRow, OFF.approach,   pairs[i].approach);
    writeText(destStartRow, OFF.deployment, pairs[i].deployment);
    writeText(destStartRow, OFF.monitor,    pairs[i].monitoringProcess);
    writeText(destStartRow, OFF.action,     pairs[i].action);

    // gapRows 한 줄은 자동으로 비어 있음 (필요시 높이 지정 가능)
    if (gapRows > 0) {
      const gapRow = ws.getRow(destStartRow + blockHeight);
      gapRow.height = gapRow.height || 6; // 살짝 얇게(옵션)
    }
  }

  const fileName =
    `${(orgName?.value || 'organization')}_Lv4_Documentation_${(selectedYear?.value || new Date().getFullYear())}.xlsx`;
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }), fileName);
};

const statsTableRef = ref(null);

const downloadExcel = () => {
  const tableEl = statsTableRef.value;
  if (!tableEl) return;

  // 1) 현재 테이블을 그대로 시트로
  const wb = XLSX.utils.table_to_book(tableEl, { sheet: "IMS Report" });
  const ws = wb.Sheets["IMS Report"];

  // 2) 맨 아래에 Total 한 줄 추가 (원하는 위치/형식으로 조정 가능)
  if (totalScoreVal.value != null) {
    XLSX.utils.sheet_add_aoa(
      ws,
      [[
        "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Total", 
        Number(totalScoreVal.value.toFixed(1))
      ]],
      { origin: -1 } // 시트의 마지막 행 뒤에 추가
    );
  }

  // 3) 파일명
  const yyyy = new Date().getFullYear();
  const name = orgName.value || "organization";
  XLSX.writeFile(wb, `${name}_IMS_${selectedYear.value || yyyy}.xlsx`);
};
</script>

<style scoped>
.stats-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.stats-table th{
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center; /* 셀 텍스트 수평 중앙 정렬 */
  vertical-align: middle; /* 셀 텍스트 수직 중앙 정렬 */
  line-height: 1.6; /* 줄 간격 조정 */
  font-size: 12px;
}
.stats-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center; /* 셀 텍스트 수평 중앙 정렬 */
  vertical-align: middle; /* 셀 텍스트 수직 중앙 정렬 */
  line-height: 1.4;
  font-size: 10px;
}

.stats-table th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

.stats-table td {
  vertical-align: top;
}

/* 요약 테이블 스타일 */

.summary-table-container {
  background-color: white; /* 배경색 유지 */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
  border-bottom: 2px solid #ddd; /* 하단 테두리 */
  overflow: hidden; /* 전체 페이지 스크롤 제거 */
  display: flex;
  flex-direction: column;
}


.summary-table {
  position: sticky;
  top: 0; /* 화면 상단 고정 */
  z-index: 10; /* 통계 테이블보다 위에 배치 */
  background-color: white; /* 배경색 추가 */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
  border-bottom: 2px solid #ddd; /* 구분선 */
}

.summary-table th,
.summary-table td {
  border: 1px solid #000;
  padding: 10px;
}

/* 📌 고정된 영역이 상단에 가려지지 않도록 공간 추가 */
.container {
  padding-top: 60px; /* 요약 테이블 높이만큼 패딩 추가 */
}

.summary-table .highlight {
  background-color: #00a651;
  color: #fff;
  font-weight: bold;
}


/* 점수에 따른 배경색 */
.score-excellent {
  background-color: #00a651; /* 매우 충족 - 초록 */
  color: white;
}

.score-satisfactory {
  background-color: #92d050; /* 충족 - 연두 */
  color: black;
}

.score-needs-improvement {
  background-color: #ffff00; /* 개선여지 - 노랑 */
  color: black;
}

.score-weak {
  background-color: #ffc000; /* 취약 - 주황 */
  color: black;
}

.score-very-weak {
  background-color: #ff0000; /* 매우 취약 - 빨강 */
  color: white;
}

.score-pending {
  background-color: #eaeaea; /* 0.00 - 회색 */
  color: black;
}

/**  통계 데이터의 헤더가 따라옴*/
.stats-table thead tr {
  z-index: 5; /* 요약 테이블보다 아래에 위치 */
  background-color: #f4f4f4; /* 배경색 (겹치는 부분 가독성) */
  border-bottom: 2px solid #ddd; /* 헤더 하단 선 */
  padding: 8px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

.excel-download-container {
  position: static !important;   /* ← fixed 끊기 */
  top: auto !important;
  right: auto !important;

  display: flex;
  justify-content: flex-end;     /* 우측 정렬 원하면 */
  gap: 8px;
  margin: 0px 0 12px;            /* <br> 아래 여백 */
}

.excel-download-btn {
  background-color: #007bff; /* 파란색 버튼 */
  color: white; /* 텍스트 색상 */
  border: none;
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
  margin-left: 5px;
  margin-top : -2px;
}

.excel-download-btn:hover {
  background-color: #0056b3; /* 호버 시 색상 */
}

.summary-container {
  max-width: 100%;
  overflow-x: auto; /* 가로 스크롤 가능하도록 설정 */
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9fafc;
  padding: 15px;
}

.summary-container h4 {
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.overall-summary-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.overall-summary-table th,
.overall-summary-table td {
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 12px;
}

.overall-summary-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.overall-summary-table td {
  font-size: 12px;
  font-weight: bold;
}
/* 평균 컬럼을 검게 */
.avg-score {
  background-color: #f4f4f4; /* 검은색 배경 */
  font-weight: bold; /* 글씨 굵게 */
}

/* 🔵 통계 테이블 컨테이너 (여기서만 스크롤 발생) */
.stats-table-container {
  max-height: 85vh; /* 📌 통계 테이블의 최대 높이 지정 */
  overflow-y: auto; /* 📌 세로 스크롤만 활성화 */
  border: 1px solid #ddd;
}

.year-dropdown {
  margin-left: 10px; /* 간격 추가 */
  padding: 2px 2px; /* 내부 패딩 */
  border: 1px solid #ccc; /* 테두리 스타일 */
  border-radius: 4px; /* 둥근 모서리 */
  font-size: 14px; /* 글꼴 크기 */
  cursor: pointer; /* 포인터 커서 */
  height: 25px;
  width: 50px;
  text-align: center;
}

.year-dropdown:focus {
  border-color: #0078d7; /* 포커스 시 테두리 색상 변경 */
  outline: none;
}

.excel-actions { 
  display: flex; 
   justify-content: flex-end; /* 👉 오른쪽 정렬 */
  gap: 8px;        /* 버튼 사이 간격 */
  flex-wrap: wrap; /* 줄바꿈 허용(폭 좁을 때) */
  align-items: center;
}

.principle-code-badge{
  max-width: 1px
}

.principle-name {
  max-width: 1px
}

.principle-cell { /* 선택 사항: 안전빵으로 동일 폭 부여 */
  width: 30px;
}

</style>



